export default __webpack_public_path__ + "static/services-bg-e11d8fcb3a20bd2c3363aa830cfdbf79.jpg";